module.exports = __webpack_public_path__ + "img/order-icon-1.74c893ce.png";